import PropTypes from 'prop-types';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import useAuth from "hooks/useAuth";
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { ProfileOutlined, LogoutOutlined, UserOutlined, WalletOutlined } from '@ant-design/icons';






//-------------------------------------
const ProfileTab = ({ handleLogout }) => {
  const { user } = useAuth();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const navigate = useNavigate();
  
  const handleListItemClick = (event, index) => {
    switch (index) {
      case 1:
        // Handle Datos de contacto
        navigate('/cuenta/datos-contacto');
        break;
      case 2:
        handleLogout();
        break;
      case 3:
        // Handle Soporte
        navigate('/cuenta/soporte');
        break;
      case 4:
        // Handle Estado de cuenta
        navigate('/cuenta/estado-cuenta');
        break;
      default:
        break;
    }
    setSelectedIndex(index);
  };



  //-------------------------------------
  // Check if user has required role to access menu items
  const hasAccessRole = user?.role === 1 || user?.role === 100;

  return (
    <List component="nav" sx={{ p: 0, '& .MuiListItemIcon-root': { minWidth: 32 } }}>
      
      {/* <ListItemButton selected={selectedIndex === 0} onClick={(event) => handleListItemClick(event, 0)}>
        <ListItemIcon>
          <EditOutlined />
        </ListItemIcon>
        <ListItemText primary="Edit Profile" />
      </ListItemButton> */}

      {hasAccessRole && (
        <ListItemButton 
          selected={selectedIndex === 1} 
          onClick={(event) => handleListItemClick(event, 1)}
        >
          <ListItemIcon>
            <UserOutlined />
          </ListItemIcon>
          <ListItemText primary="Datos de contacto" />
        </ListItemButton>
      )}

      {hasAccessRole && (
        <ListItemButton 
          selected={selectedIndex === 4} 
          onClick={(event) => handleListItemClick(event, 4)}
        >
          <ListItemIcon>
            <WalletOutlined />
          </ListItemIcon>
          <ListItemText primary="Estado de cuenta" />
        </ListItemButton>
      )}

      {hasAccessRole && (
        <ListItemButton 
          selected={selectedIndex === 3} 
          onClick={(event) => handleListItemClick(event, 3)}
        >
          <ListItemIcon>
            <ProfileOutlined />
          </ListItemIcon>
          <ListItemText primary="Soporte" />
        </ListItemButton>
      )}

      <ListItemButton selected={selectedIndex === 2} onClick={handleLogout}>
        <ListItemIcon>
          <LogoutOutlined />
        </ListItemIcon>
        <ListItemText primary="Cerrar sesión" />
      </ListItemButton>
    </List>
  );
};

ProfileTab.propTypes = {
  handleLogout: PropTypes.func
};

export default ProfileTab;
